import { useMemo } from 'react';
import useBookingBill from '@/features/dashboard/bookingChanges/hooks/useBookingBill.ts';
import useGetOpenDraft from '@/features/dashboard/bookingChanges/hooks/useGetOpenDraft.ts';
import useChangePreview from '@/features/dashboard/bookingChanges/hooks/useChangePreview.ts';
import { bookingChangeDetailMapper } from '@/features/dashboard/bookingChanges/types/BookingChangeDetailDto.mapper.ts';
import { ChangeDraftVm } from '@/features/dashboard/bookingChanges/types/ChangeViewModel.ts';

/**
 * Otwarty szkic w postaci modelu widoku — spina panel boczny, belkę nagłówka
 * i modal wyjścia z edycji. Rozbicie wpływu na osoby powstaje w mapperze,
 * bo backend zwraca jedną zagregowaną kwotę.
 */
const useChangeDraft = (bookingId: string | undefined) => {
  const billQuery = useBookingBill(bookingId);
  const draftQuery = useGetOpenDraft(bookingId);
  const previewQuery = useChangePreview(bookingId);
  const draft: ChangeDraftVm | null = useMemo(() => {
    const change = draftQuery.data;
    if (!billQuery.data || !change) {
      return null;
    }
    return bookingChangeDetailMapper.toDraftVm(
      change,
      billQuery.data,
      previewQuery.preview,
    );
  }, [billQuery.data, draftQuery.data, previewQuery.preview]);

  return {
    draft,
    change: draftQuery.data ?? null,
    isLoading:
      billQuery.isLoading || draftQuery.isLoading || previewQuery.isLoading,
    isError: billQuery.isError || draftQuery.isError,
    /** Odmowa podglądu — kwot szkicu nie znamy, więc ekran mówi to wprost. */
    previewError: previewQuery.error,
  };
};

export default useChangeDraft;
